import { post } from '../apiService';

export const updateResourceMatrix = async (
  field: string,
  uuid: string,
  value: string
): Promise<{ data: string; loading: boolean }> => {
  const url =
    'https://gateway-bso7uhc0.wl.gateway.dev/resourceMatrixUpdate';
  const requestBody = {
    field,
    uuid,
    value,
  };
  let loading = true;
  try {
    const data = await post<string>(url, requestBody);
    loading = false;
    return { data, loading };
  } catch (error) {
    console.error('Failed to update resource matrix:', error);
    throw new Error('Failed to update resource matrix');
  }
};
